exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#process {\n  position: absolute;\n  z-index: 100;\n  width: 100%;\n  height: 100%;\n  top: 0px;\n  left: 0px;\n  text-align: center;\n}\n#process .process-content {\n  position: absolute;\n  display: block;\n  width: 100px;\n  height: 100px;\n  top: 50%;\n  left: 50%;\n  padding: 25px 0px;\n  margin-top: -50px;\n  margin-left: -50px;\n  border-radius: 4px;\n  box-sizing: border-box;\n}\n#process .process-content img {\n  width: 20px;\n  height: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-0ae76107","scoped":false,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/loading/loading.vue
// module id = 34
// module chunks = 1 2 3 4 5 7